// src/store/thunks/sixCatalog/deleteSixThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';
import { fetchSixCatalogThunk } from '@/store/thunks/sixCatalog/fetchSixCatalog';

export const deleteSixThunk = createAppAsyncThunk<undefined, string>(
  'sixCatalog/deleteSix',
  withLoader(
    async(sixId, { extra, dispatch }) => {
      await extra.sixCatalogService.deleteSix(sixId);
      await dispatch(fetchSixCatalogThunk()).unwrap();
      return undefined;
    }
  )
);
